export default __webpack_public_path__ + "/assets/progetto_3.jpg";